import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=01f7f27e&scoped=true&"
import script from "./JobView.vue?vue&type=script&lang=js&"
export * from "./JobView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7f27e",
  null
  
)

export default component.exports